import React from "react";
import { QueryLoader } from "@jsq/ds/core";
import { useGetConsolidatedPaymentPrefForPositionQuery } from "#graphql/supergraphHooks";
import { clientContext } from "#utils/graphql_utils";
import {
  ExistingPaymentPrefDisplay,
  ExistingPaymentPrefDisplayProps,
} from "../ExistingPaymentPrefDisplay";
import { PaymentPrefDisplayCardContainer } from "../PaymentPrefDisplayCardContainer";
import { getPaymentMethodIconType } from "../PaymentPrefDisplayCardContainer/utils";
import type { CheckDisplayOverride } from "../../common/types";

export type ExistingPaymentPrefDisplayWithIdProps = Omit<
  ExistingPaymentPrefDisplayProps,
  "paymentPref"
> & {
  paymentPrefId: string;
  showBankDomicile?: boolean;
  isFullWidth?: boolean;
  checkDisplayOverride?: CheckDisplayOverride;
};

/**
 * Wrapper component for ExistingPaymentPrefDisplay that adds an ID prop.
 */
export const ExistingPaymentPrefDisplayWithId: React.FC<
  ExistingPaymentPrefDisplayWithIdProps
> = ({ paymentPrefId, showBankDomicile, isFullWidth, ...props }) => {
  const result = useGetConsolidatedPaymentPrefForPositionQuery({
    variables: {
      paymentPrefIds: [paymentPrefId],
    },
    context: clientContext(),
    fetchPolicy: "no-cache",
  });

  const paymentPref = result.data?.paymentPrefs?.[0];
  const iconType = paymentPref ? getPaymentMethodIconType(paymentPref) : "money-check";

  return (
    <QueryLoader result={result}>
      {paymentPref ? (
        <PaymentPrefDisplayCardContainer iconType={iconType} isFullWidth={isFullWidth}>
          <ExistingPaymentPrefDisplay
            {...props}
            paymentPref={paymentPref}
            showBankDomicile={showBankDomicile}
            isFullWidth={isFullWidth}
          />
        </PaymentPrefDisplayCardContainer>
      ) : null}
    </QueryLoader>
  );
};
